import React, { useEffect, useState } from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { Preload } from "../../components/Preload";
import {
  GET_DATA_OBJECT_DESIGN,
  GET_FILTER_PROPS,
} from "../../graphql/Queries/ObjectQuery";
import {
  CHANGE_SORT_FILTER_PROPS,
  CHANGE_SORT_STEP,
} from "../../graphql/Mutations/ObjectTypeMutation";
import Nestable from "react-nestable";
import { Step } from "../../components/Sort/Step";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import i18next from "i18next";
import { GET_FAQ_TABS } from "../../graphql/Queries/FaqQuery";
import { getField } from "../../utils/Helper";
import { FAQ_TABS_SORT } from "../../graphql/Mutations/FaqMutation";
import { FAQ_PAGE, finder } from "../../utils/Dictionaries";

export const FaqTabSort = ({ id = null }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [changeSortStep] = useMutation(FAQ_TABS_SORT);
  const { load, error, data } = useQuery(GET_FAQ_TABS, {
    variables: {
      sort: "sort",
      direction: "asc",
    },
    fetchPolicy: "no-cache",
  });
  if (error) {
    toast.error(error.message);
  }
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (data) {
      setItems(data.faqTabs);
    }
  }, [data]);

  const SortableItem = SortableElement(({ item }) => {
    return (
      <div className="dd-list" style={{ marginBottom: 10 }}>
        <div className="dd-item">
          <div
            className="dd-handle"
            style={{ backgroundColor: "rgb(196, 198, 198)" }}
          >
            <div>
              <span>
                {getField(item.name, "value")} [{finder(FAQ_PAGE, item.page)}]
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <di>
        {items.map((item, index) => {
          return (
            <SortableItem key={`item-${index}`} index={index} item={item} />
          );
        })}
      </di>
    );
  });

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={"Редактировать расположение"}
        breadcrumbs={[
          {
            slug: "/faq-tabs",
            name: "Группы для FAQ",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <Row>
                <Col md={12}>
                  <SortableList
                    items={items}
                    onSortEnd={({
                      oldIndex,
                      newIndex,
                      collection,
                      isKeySorting,
                    }) => {
                      const _steps = [...items];
                      const el = _steps[oldIndex];
                      _steps.splice(oldIndex, 1);
                      _steps.splice(newIndex, 0, el);
                      setItems(_steps);
                      const arr = [];
                      _steps.map((item, index) => {
                        arr.push({ id: item.id, sort: index + 1 });
                      });
                      changeSortStep({
                        variables: {
                          arr: JSON.stringify(arr),
                        },
                      })
                        .then((response) => {
                          console.log("[Log]", response.data);
                        })
                        .catch((error) => {
                          console.log("[Err]", error);
                        });
                    }}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
